import $ from 'jquery';
import { SCHEDULE_CONFIG as C } from './scheduleConfig';
import { parseKey } from './dateUtils';

const toUnix = (d) => Math.trunc(d.getTime() / 1000).toString();

/** Диапазон одного дня: [день 10:00 ; день 23:59:59] */
export function getDayRange(key) {
    const start = parseKey(key);
    start.setHours(C.DAY_START_HOUR, 0, 0, 0);
    const finish = parseKey(key);
    finish.setHours(23, 59, 59, 0);
    return { start, finish };
}

/**
 * Загрузка слотов врача за диапазон. Возвращает jqXHR (его можно await-ить и .abort()-ить).
 * Ответ: { draw, recordsTotal, recordsFiltered, data: [{ t, d<staffId>: {...} }] }
 */
export function fetchSchedule({ staffId, start, finish, length = C.REQUEST_LENGTH }) {
    return $.ajax({
        url: global.api_url + '/schedule/datatable',
        headers: { Authorization: 'Bearer ' + sessionStorage.getItem('token') },
        type: 'post',
        contentType: 'application/json',
        data: JSON.stringify({
            draw: 0,
            start: 0,
            length,
            columns: [
                { orderable: false, searchable: false, data: 't', name: 't' },
                { data: 'd' + staffId, name: '*', searchable: false, orderable: false },
            ],
            Filter: {
                positivId: C.POSITIV_ID,
                interval: C.INTERVAL,
                start: toUnix(start),
                finish: toUnix(finish),
            },
        }),
    });
}

export const fetchDay = (staffId, key) => fetchSchedule({ staffId, ...getDayRange(key) });


export const fetchRange = (staffId, from, to) => {
    const start = parseKey(from);
    start.setHours(C.DAY_START_HOUR, 0, 0, 0);

    const finish = parseKey(to);
    finish.setHours(23, 59, 59, 0);

    return fetchSchedule({
        staffId,
        start,
        finish,
    });
};